import { createReducer } from '@reduxjs/toolkit';

import { videoPlayError } from '../actions';
import { VideoState } from '~/types/redux/share';

const videoReducer = createReducer<VideoState>({}, (builder) => {
  builder.addCase(videoPlayError, (state, action) => {
    state.error = action.payload.value;
  });
});

export default videoReducer;
